import { getPeriodStatusComp } from "../../../utils";
import TransactionSummary from "../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/transactionSummary";
import TransactionSummaryForBee from "./SummaryTransactionForBee";

const HoneypotTableHeaderInfo = ({selectedYear, selectedPeriod, period, userId}) => {
  const HoneypotTableHeaderInfo = {
    padding: '1em',
    margin: '0 0 1px 0',
    borderRadius: '1em 1em 0 0',
    backgroundColor: 'white',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  }

  return ( 
    <div style={HoneypotTableHeaderInfo} >

    <div style={{ margin:'0 1em 0 0' }} >

      <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0.5em 0' }} >
        <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Displayed Period:</p>
        <p style={{ whiteSpace: 'nowrap' }} >{selectedPeriod}</p>
      </div>

      <div style={{ display: 'flex', flexWrap: 'nowrap' }} >
        <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Status:</p>
        <p style={{ whiteSpace: 'nowrap', fontWeight: '600', }} >{ getPeriodStatusComp(period) }</p>
        {/* Status can be 'Current', 'Pending', or 'Completed' */}
      </div>
    </div>
    <TransactionSummaryForBee selectedYear={selectedYear} selectedPeriod={selectedPeriod} userID={userId}  />

  </div>
   );
}
 
export default HoneypotTableHeaderInfo;
